// extracted by mini-css-extract-plugin
export default {"wrapper":"wg23u29EvdNjPj20l9aE"};